import React from "react";
import { NavLink } from "react-router-dom";
import ResetLocation from "../../helpers/ResetLocation";

const FooterMenu = () => {
  return (
    <ul className="footer__menu  flex-container flex-column">
      <li>
        <NavLink
          style={({ isActive }) =>
            isActive
              ? {
                textDecoration: "none",
                color: "#ff6240",
              }
              : {}
          }
          onClick={ResetLocation}
          className="txt-white"
          to="/menu"
        >
          Speisekarte
        </NavLink>
      </li>

      <li>
        <NavLink
          style={({ isActive }) =>
            isActive
              ? {
                textDecoration: "none",
                color: "#ff6240",
              }
              : {}
          }
          onClick={ResetLocation}
          className="txt-white"
          to="/blog"
        >
          Blog
        </NavLink>
      </li>
      <li>
        <NavLink
          style={({ isActive }) =>
            isActive
              ? {
                textDecoration: "none",
                color: "#ff6240",
              }
              : {}
          }
          onClick={ResetLocation}
          className="txt-white"
          to="/about"
        >
          Über uns
        </NavLink>
      </li>
      <li>
        <NavLink
          style={({ isActive }) =>
            isActive
              ? {
                textDecoration: "none",
                color: "#ff6240",
              }
              : {}
          }
          onClick={ResetLocation}
          className="txt-white"
          to="/contact"
        >
          Kontakt
        </NavLink>
      </li>
      <li>
        <a
          href="https://casaantonio.at"
          target="_blank"
          rel="noopener noreferrer"
          className="txt-white"
        >
          casaantonio.at
        </a>
      </li>
    </ul>
  );
}
export default FooterMenu
